import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../app.service';
import { ErrorService } from '../error/error.service';
import { LandingComponent } from '../landing/landing.component';
import { SwitchService } from './switch.service';
import { TravellersService } from '../travelers/travellers.service';
import { TravelersService } from '../travelers/travelers.service';
import { LandingService } from '../landing/landing.service';
import { HttpService } from '../../services/http.service';
import { AccessibilityService } from '../../services/accessibility.service';
import { AuthService } from '@auth0/auth0-angular';
import { UtilService } from 'src/app/util.service';

@Component({
  selector: 'app-switch',
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.css']
})
export class SwitchComponent implements OnInit {
  deviceType: string;
  urls: any;
  wifiConnect = false;
  showSwitchErrorMessage = false;
  enableListDevice = false;
  public deviceTypeData: any;
  public selectedDeviceName: any;
  public connectedDeviceCount: any;
  public maxCountDevices: any;
  public currentDeviceName: any;
  public deviceInfoRequest: any;
  public total: any;
  public deviceInfoResponse: any;

  constructor(
    private appService: AppService,
    private switchService: SwitchService,
    private errorService: ErrorService,
    private httpService: HttpService,
    private accessibilityService: AccessibilityService,
    private router: Router,
    private travelersService: TravelersService,
    private travellersService: TravellersService,
    private authService: AuthService,
    private utils: UtilService,
    private landingService: LandingService) { }

  ngOnInit() {
    this.urls = this.switchService.getUrls();
    this.deviceTypeData = this.switchService.getDeviceTypeData();
    this.deviceInfoResponse = this.switchService.getConnectedCount();
    const strong = '<strong>';
    const endStrong = '</strong>';
    const divideStr = '/';
    const devices = [];
    let connectCount = 0;
    if (this.deviceInfoResponse.devices) {
      for (const j in this.deviceInfoResponse.devices) {
        if (this.deviceInfoResponse.devices[j].status.code === 'FULL') {
          devices.push(this.deviceInfoResponse.devices[j]);
          connectCount++;
        }
      }
      this.deviceTypeData.devices = devices;
      this.deviceType = this.deviceTypeData.devices[0].type;
    }
    this.total = strong + connectCount + divideStr + connectCount + endStrong;
    this.currentDeviceName = strong + this.landingService.getDeviceName() + endStrong;
    this.appService.removeScrollBody();
    this.appService.hideLoaderWithText();
    this.appService.hideLoader();
    this.accessibilityService.focus('#switch-buy-more');
    this.selectedDeviceName = '';
  }

  closeSwitchOverlay() {
    this.appService.addScrollBody();
    const sessionId = this.appService.getSessionId();
    const loginFromActivate = this.switchService.getLoginFromActivate();
    if (sessionId && loginFromActivate) {
      this.appService.customerLogoutFromActivate();
      this.authService.logout();
      this.utils.newEBUserLogout();
    }
    this.errorService.removeError();
    this.appService.removeCustomerErrors();
    LandingComponent.showSwitchScreen = false;
    LandingComponent.showActivateScreen = false;
    this.appService.scrollToTop();
    this.accessibilityService.focus('#landing-connect');
  }

  goToActivateScreen() {
    this.appService.showLoader();
    this.errorService.removeError();
    const sessionId = this.appService.getSessionId();
    const loginFromActivate = this.switchService.getLoginFromActivate();
    if (sessionId && loginFromActivate) {
      this.appService.customerLogoutFromActivate();
      this.switchService.setLoginFromActivate(false);
      this.authService.logout();
      this.utils.newEBUserLogout();
    } else {
      this.appService.customerLogoutFromLanding();
      this.authService.logout();
      this.utils.newEBUserLogout();
    }
    LandingComponent.showSwitchScreen = false;
    this.landingService.showActivateScreen();
    LandingComponent.showActivateScreen = true;
    this.appService.showPnrFromSwitch();
  }

  connectToWifi() {

    if (this.selectedDeviceName !== '') {
      this.appService.showLoader();
      const switchDeviceRequest = this.switchService.getSwitchDeviceRequest();
      this.httpService.postData(switchDeviceRequest).subscribe(
        switchDeviceResponse => {
          if (switchDeviceResponse.errors) {
            this.errorService.addError(switchDeviceResponse.errors);
            this.appService.hideLoader();
          } else if (switchDeviceResponse.devices) {
            for (const device of switchDeviceResponse.devices) {
              if (device.status.code === 'FULL') {
                this.landingService.getNetFlixBanner(device.status.code);
                this.landingService.hideLandingBannerText();
                LandingComponent.isDeviceActivated = true;
                LandingComponent.showSwitchScreen = false;
                LandingComponent.showLandingBanner = false;
                this.errorService.addConnectedNotification();
                this.appService.changeDisconnectWifiStatus();
                this.appService.showLandingCustomer();
                this.appService.addScrollBody();
                const thisVal = this.appService;
                setTimeout(function () { thisVal.hideLoader(); }, 110);
                this.appService.scrollToTop();
              }
            }
          } else {
            this.errorService.addError(this.landingService.getDefaultError());
            this.appService.hideLoader();
          }
        },
        error => {
          this.errorService.addError(this.landingService.getDefaultError());
          this.appService.hideLoader();
        }
      )
    } else {
      this.showSwitchErrorMessage = true;
    }

  }

  public onChangeDevice(deviceIndex, event) {
    this.showSwitchErrorMessage = false;
    this.accessibilityService.updateAttributeValue('#switch-device', 'aria-expanded', 'true');
    this.selectedDeviceName = event.target[event.target.selectedIndex].label;
    this.switchService.setSwitchDeviceRequest(this.deviceTypeData.devices[deviceIndex].token);
    this.accessibilityService.updateAttributeValue('#switch-device', 'aria-expanded', 'false');
    event.preventDefault();
    this.accessibilityService.focus('#switch-device');
  }

  public goToBuywifi() {
    LandingComponent.showSwitchScreen = false;
    if(this.appService.isCharter) {      
      this.landingService.setChatBotHide();
      LandingComponent.showPaymentSelectionScreen = true;
      LandingComponent.isbuyButtonTrigger = true;
      this.errorService.removeError();
    }
    else {
      this.landingService.setChatBotHide();      
      LandingComponent.showPaymentSelectionScreen = true;
      this.errorService.removeError();    
    }
  }  

  /* Accessibility related methods */
  keydownEvent(event, id) {
    event.preventDefault();
    if (id === 'switch') {
      if (!this.enableListDevice) {
        this.accessibilityService.focus('#close-switch');
      } else {
        this.accessibilityService.focus('#switch-device');
      }
    } else if (id === 'switchshift') {
      if (!this.enableListDevice) {
        this.accessibilityService.focus('#list-device');
      } else {
        this.accessibilityService.focus('#connect-anyways');
      }
    } else {
      this.accessibilityService.focus(id);
    }

  }

  keydownSwitchbox(event) {
    if (event.keyCode === 9) {
      this.accessibilityService.updateAttributeValue('#switch-device', 'aria-expanded', 'true');
    } else {
      this.accessibilityService.updateAttributeValue('#switch-device', 'aria-expanded', 'false');
    }
  }

  @HostListener('window:keydown', ['$event'])
  keyboardEents(event) {
    if (event.key === 'Escape') {
      this.closeSwitchOverlay();
    } else {
      this.wifiConnect = false;
    }
  }

  listDevice() {
    this.accessibilityService.focus('#list-device');
    if (!this.enableListDevice) {
      this.enableListDevice = true;
      this.appService.removeScrollBody();
      this.accessibilityService.updateAttributeValue('#list-device', 'aria-expanded', 'true');
    } else if (this.enableListDevice) {
      this.accessibilityService.updateAttributeValue('#list-device', 'aria-expanded', 'false');
      this.enableListDevice = false;
      this.appService.addScrollBody();
    }
  }

}
